import { render, staticRenderFns } from "./CutPettyCash.vue?vue&type=template&id=5048af56&"
import script from "./CutPettyCash.vue?vue&type=script&lang=js&"
export * from "./CutPettyCash.vue?vue&type=script&lang=js&"
import style0 from "./CutPettyCash.vue?vue&type=style&index=0&id=5048af56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports